import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/appointment/types'
import AppointmentEntity, { IAppointmentProps, IAppointmentQueryProps } from '@/entities/Appointment'
import { IResponseProps } from '@/entities/Response'

export default class AppointmentRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<IAppointmentProps>) {
    this.store.commit(new types.Store(value))
  }

  get data(): IResponseProps<IAppointmentProps> {
    return this.store.state.appointment.response
  }

  set current(value: IAppointmentProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): IAppointmentProps | null {
    return this.store.state.appointment.current
  }

  get entity(): AppointmentEntity {
    return new AppointmentEntity(this.store.state.appointment.current)
  }

  set query(value: IAppointmentQueryProps) {
    this.store.commit(new types.Query({ ...value }))
  }

  get query(): IAppointmentQueryProps {
    return { ...this.store.state.appointment.query }
  }

  set type(value: string) {
    this.cookies.set(process.env.APP_NAME + 'appointment-calendar-type', value, { path: '/', maxAge: 60 * 60 * 24 * 365 })
    this.store.commit(new types.Type(value))
  }

  get type(): string {
    const type = this.cookies.get(process.env.APP_NAME + 'appointment-calendar-type') || 'week'

    return this.store.state.appointment.type || (type !== 'list' ? type : 'week')
  }

  get open(): boolean {
    return this.store.state.appointment.open
  }

  set open(value: boolean) {
    this.store.commit(new types.Open(value))
  }

  set scrollTop(value: number) {
    this.store.commit(new types.ScrollTop(value))
  }

  get scrollTop(): number {
    return this.store.state.appointment.scrollTop
  }
}
